function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("ellipse", {
  cx: 25,
  cy: 24.238,
  rx: 25,
  ry: 23.988,
  fill: "#E4E7EC"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.283 36.077l14.589 11.84c9.274-1.394 16.854-7.584 19.838-15.941L29.194 13.25 16.533 36.077h-2.25z",
  fill: "#D4DAE1"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27.823 24.47c1.612-1.547 2.741-4.1 2.741-6.345 0-3.482-1.29-6.268-5.645-6.268-4.355 0-5.645 2.786-5.645 6.268 0 2.244 1.13 4.875 2.742 6.345-3.468.774-6.841 3.405-8.051 10.06-.403 2.09 1.613 2.09 1.613 2.09H34.26c.08 0 2.016 0 1.612-2.09-1.128-6.655-4.583-9.286-8.05-10.06z",
  fill: "#fff"
});
var _ref4 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 24.583,
  cy: 18.64,
  rx: 7.083,
  ry: 6.797,
  fill: "#fff"
});
function SvgLightGrayAvatar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 50 49",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4);
}
export default __webpack_public_path__ + "fonts/light-gray-avatar-1c636dad626310f4efc488a37e875abb.svg";
export { SvgLightGrayAvatar as ReactComponent };